import React, { Component } from 'react';
import PropTypes from 'prop-types';
import impstyles from '../styles/SearchStyles.module.scss';
import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import Autocompl from './autoComplete';
import '../styles/table.css';
import Context from '../context/Context';
import { searchItems, searchItemsForVendors, searchWpidItemsInfo } from '../services/apiService';
import Collapse from '@mui/material/Collapse';
import { Typography } from '@mui/material';
import { BlueButton, MinimalButton } from './common/customButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import MultiSelect from './MultiSelect';
import CircularProgress from '@mui/material/CircularProgress';

/* istanbul ignore next */
const styles = theme => ({
  root: {
    flexGrow: 1,
    '& .MuiSvgIcon-root': {
      height: 30,
      width: 30
    }
  },
  paper: {
    height: 398,
    width: 297,
    maxWidth: 297,
    textAlign: 'left'
  }
});

/* istanbul ignore next */
const RadioIcon = styled('span')(/* istanbul ignore next */ ({ theme }) => ({
  borderRadius: '50%',
  width: 24,
  height: 24,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5'
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(57,75,89,.5)'
        : 'rgba(206,217,224,.5)'
  }
}));

const RadioCheckedIcon = styled(RadioIcon)({
  backgroundColor: '#137cbd',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 24,
    height: 24,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""'
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3'
  }
});

const DCAutoComplete = styled(Autocompl)({
  root: {
    "& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root": {
      flexWrap: "nowrap",
      overflowX: "hidden"  // or "hidden"
    }
  }
});

// Inspired by blueprintjs
function SearchRadioBtn(props) {
  return (
    <Radio
      sx={{
        '&:hover': {
          bgcolor: 'transparent'
        }
      }}
      disableRipple
      color="default"
      checkedIcon={<RadioCheckedIcon />}
      icon={<RadioIcon />}
      {...props}
    />
  );
}

export class Search extends Component {
  constructor(props) {
    super(props);
    this.searchCardRef = React.createRef();
    this.focusRequestId = null;
    this.state = {
      itemerrorMsg: '',
      vendorErrorMsg: '',
      wpidErrorMsg: '',
      dcerrorMsg: '',
      showItemSearch: true,
      itemNumbers: [],
      problematicItemNbrs: [],
      selectedDCNbr: '',
      dcList: props.dcList,
      vendorNbrs: [],
      problematicVendorNbrs: [],
      wpidNbrs: [],
      loading: false,
      collapse: false,
      setItemSearch: true,
      selectedDcList: [],
      searchType: 'itemNumbers'
    };
  }


  toggleCollapse = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  componentDidMount() {
    this.setState({
      itemNumbers: this.context.searchedItemNbrList,
      vendorNbrs: this.context.searchedVendorNbrList,
      showItemSearch: this.context.showItemSearch,
      selectedDcList: this.context.searchedDcNbrList
    });
    if (this.context.showItemSearch === false) {
      this.setState({
        searchType: 'vendorIDs'
      });
    }
    
    /* istanbul ignore else */
    if (!this.state.collapse) {
      document.addEventListener('keydown', this.handleGlobalKeyDown, true);
    }

    this.focusAutocompleteInput();
  }


  focusAutocompleteInput = () => {
    let attempts = 0;
    const maxAttempts = 60;
    const attemptFocus = () => {
      const autocompInput = document.querySelector('#autocomp textarea');
      if (autocompInput) {
        autocompInput.focus();
        this.focusRequestId = null;
      } else if (attempts < maxAttempts) {
        attempts++;
        this.focusRequestId = requestAnimationFrame(attemptFocus);
      } else {
        this.focusRequestId = null;
      }
    };
    this.focusRequestId = requestAnimationFrame(attemptFocus);
  };

  normalizeDcList(prevProps) {
    if ((this.props.dcList !== prevProps.dcList) || (this.state.dcList && (this.state.dcList[0] + '').length === 4)) {
      let list = [...this.props.dcList];
      for (const i of list.keys()) {
        // Always coerce to a string, padding only when the raw DC number is
        // 4 digits (e.g. 6042 -> '06042'). DC numbers that are already 5
        // digits (e.g. 10001) don't need padding but must still be
        // stringified here, otherwise they're left as raw Numbers and break
        // any code downstream (DownloadDialog.js) that assumes every entry
        // in this list is a string.
        list[i] = (list[i] + '').length === 4 ? '0' + list[i] : (list[i] + '');
      }

      this.setState({
        dcList: list
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.normalizeDcList(prevProps);

    if (!this._contextSynced &&
        (this.state.itemNumbers?.length ?? 0) === 0 &&
        this.context.searchedItemNbrList?.length > 0) {
      this._contextSynced = true;
      this.setState({ itemNumbers: this.context.searchedItemNbrList });
    }

    if (prevState && prevState.collapse !== this.state.collapse) {
      if (!this.state.collapse) {
        document.addEventListener('keydown', this.handleGlobalKeyDown, true);
      } else {
        document.removeEventListener('keydown', this.handleGlobalKeyDown, true);
      }
    }

    if (
      this.props.selectedSavedSearch !== prevProps.selectedSavedSearch &&
      this.props.selectedSavedSearch
    ) {
      const savedSearch = this.props.selectedSavedSearch;

      if (savedSearch.wpids?.length > 0) {
        this.setState(
          {
            wpidNbrs: savedSearch.wpids,
            selectedDcList: savedSearch.dcNbr,
            searchType: 'wpidNumbers'
          },
          () => {
            this.onSearch(new Event('Search by Saved Search'));
          }
        );
      } else if ((savedSearch.vendorNbr?.length ?? 0) === 0) {
        this.setState(
          {
            itemNumbers: savedSearch.itemNbr,
            selectedDCNbr: savedSearch.dcNbr,
            showItemSearch: true
          },
          () => {
            this.onSearch(new Event('Search by Saved Search'));
          }
        );
      } else {
        this.setState(
          {
            vendorNbrs: savedSearch.vendorNbr,
            selectedDCNbr: savedSearch.dcNbr,
            showItemSearch: false
          },
          () => {
            this.onSearch(new Event('Search by Saved Search'));
          }
        );
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleGlobalKeyDown, true);
    /* istanbul ignore else */
    if (this.focusRequestId) {
      cancelAnimationFrame(this.focusRequestId);
    }
  }

  handleEnterKeyInSearch = event => {
    const activeElement = document.activeElement;
    const isInAutocomp = activeElement?.closest('#autocomp');
    const isInMultiSelect = activeElement?.closest('#search-multiselect');

    if (isInAutocomp || isInMultiSelect) {
      const inputValue = activeElement?.value?.trim();
      const hasActiveInput = inputValue && inputValue.length > 0;
      if (isInMultiSelect || (isInAutocomp && !hasActiveInput)) {
        const hasItems =
          this.state.itemNumbers.length > 0 ||
          this.state.vendorNbrs.length > 0 ||
          this.state.wpidNbrs.length > 0;
        if (hasItems) {
          event.preventDefault();
          event.stopPropagation();
          this.onSearch(event);
        }
      }
    }
  };

  handleGlobalKeyDown = event => {
    if (event.key === 'Enter' && !this.state.loading && !this.state.collapse) {
      this.handleEnterKeyInSearch(event);
    }
  };

  searchForItems() {
    const { itemNumbers, selectedDcList } = this.state;
    if (itemNumbers.length === 0) {
      this.setState({ itemerrorMsg: 'Enter an item number' });
      return;
    }
    searchItems(itemNumbers, selectedDcList[0])
      .then(searchResults => {
        this.cleanupAfterSearch();
        this.checkProblematicItemNbrs(searchResults);
        this.context.searchCallback(
          this.state.showItemSearch,
          itemNumbers,
          this.state.vendorNbrs,
          selectedDcList[0],
          searchResults,
          selectedDcList
        );
        this.context.selectSavedSearchCallback(null);
        this.context.closeSidenav();
      })
      .catch(err => {
        console.error(err);
        this.context.showMsgCallback('Something went wrong!');
        this.cleanupAfterSearch();
      });
  }

  searchForVendor() {
    const { vendorNbrs, selectedDcList } = this.state;
    // validate vendor numbers

    if (vendorNbrs.length === 0) {
      this.setState({ vendorErrorMsg: 'Enter a vendor number' });
      return;
    }

    Promise.all(vendorNbrs.map(vn => searchItemsForVendors([vn], selectedDcList[0])))
      .then(results => {
        this.cleanupAfterSearch();
        const validVendorNbrs = results.flatMap(r => r.validVendorNbrs);
        const itemInfo = results.flatMap((r, i) =>
          r.itemInfo.map(item => Object.assign(item, { _searchedVendorNbr: vendorNbrs[i] }))
        );
        this.checkProblematicVendorNbrs(validVendorNbrs, vendorNbrs);
        this.context.searchCallback(
          this.state.showItemSearch,
          this.state.itemNumbers,
          vendorNbrs,
          selectedDcList[0],
          itemInfo,
          selectedDcList
        );
        this.context.selectSavedSearchCallback(null);
        this.context.closeSidenav();
      })
      .catch(err => {
        console.error(err);
        this.context.showMsgCallback('Something went wrong!');
        this.cleanupAfterSearch();
      });
  }

  onSearch = e => {
    e.preventDefault();
    const multiSelectInput = document.querySelector('#search-multiselect input');
    let finalDcList = [...this.state.selectedDcList];
    const typedValue = multiSelectInput?.value?.trim();
    if (typedValue && /^\d+$/.test(typedValue)) {
      const paddedDC = typedValue.length === 4 ? '0' + typedValue : typedValue;
      if (this.state.dcList.includes(paddedDC) && !finalDcList.includes(paddedDC)) {
        finalDcList.push(paddedDC);
      }
    }
    this.setState(prevState => {
      const dcListToSearch = finalDcList.length === 0 ? prevState.dcList : finalDcList;
      return { selectedDcList: dcListToSearch, loading: true };
    }, () => {
      this.searchItemVendor();
    });
  };

  searchItemVendor() {
    if (this.state.searchType === 'wpidNumbers') {
      this.searchForWpid();
    } else if (this.state.showItemSearch) {
      this.searchForItems();
    } else {
      this.searchForVendor();
    }
  }

  searchForWpid() {
    const { wpidNbrs, selectedDcList } = this.state;
    if (wpidNbrs.length === 0) {
      this.setState({ wpidErrorMsg: 'Enter a WPID' });
      return;
    }
    searchWpidItemsInfo(wpidNbrs, selectedDcList[0])
      .then(searchResults => {
        this.cleanupAfterSearch();
        this.context.searchCallback(
          true,
          [],
          [],
          selectedDcList[0],
          searchResults,
          selectedDcList,
          true
        );
        this.context.selectSavedSearchCallback(null);
        this.context.closeSidenav();
      })
      .catch(err => {
        console.error(err);
        this.context.showMsgCallback('Something went wrong!');
        this.cleanupAfterSearch();
      });
  }

  cleanupAfterSearch() {
    this.setState(
      { loading: false, itemerrorMsg: '', vendorErrorMsg: '', wpidErrorMsg: '', dcerrorMsg: '' },
    );
  }

  resetSearch() { // NOSONAR - exposed via ref, called by dashboard.js
    this.setState(
      {
        itemerrorMsg: '',
        vendorErrorMsg: '',
        wpidErrorMsg: '',
        dcerrorMsg: '',
        showItemSearch: true,
        itemNumbers: [],
        problematicItemNbrs: [],
        selectedDCNbr: '',
        vendorNbrs: [],
        problematicVendorNbrs: [],
        wpidNbrs: [],
        loading: false,
        collapse: false,
        setItemSearch: true,
        selectedDcList: [],
        searchType: 'itemNumbers',
        searchedDcNbrList: []
      }
    );
  }

  checkProblematicItemNbrs(searchResults) {
    const { itemNumbers } = this.state;
    if (searchResults.length !== itemNumbers.length) {
      // generic error message
      const validItemNbrSet = new Set(searchResults.map(res => res.itemNbr));
      const problematicItemNbrs = itemNumbers.filter(
        itemNbr => !validItemNbrSet.has(itemNbr)
      );
      console.log('problematicItemNbrs', problematicItemNbrs);
      this.setState({
        itemerrorMsg: 'Please check if all items are valid and authorized.',
        problematicItemNbrs
      });
    }
  }
  checkProblematicVendorNbrs(validVendorNbrs, vendorNbrs) {
    if (validVendorNbrs.length !== vendorNbrs.length) {
      // converted to number since, backend outputs a number
      const problematicVendorNbrs = vendorNbrs.filter(
        vendorNbr => !validVendorNbrs.includes(Number(vendorNbr))
      );
      console.log('problematicVendorNbrs ', problematicVendorNbrs);
      this.setState({
        vendorErrorMsg:
          'Please check if all vendor numbers are valid and authorized.',
        problematicVendorNbrs
      });
    }
  }
  autocompleteValCallback(val) {
    if (this.state.searchType === 'wpidNumbers') {
      this.setState({ wpidNbrs: val ?? [], wpidErrorMsg: '' });
    } else if (this.state.showItemSearch) {
      this.setState({ itemNumbers: val ?? [], itemerrorMsg: '' });
    } else {
      this.setState({ vendorNbrs: val ?? [], vendorErrorMsg: '' });
    }
  }
  selectDCCallback(val) { // NOSONAR - exposed as prop callback, used by select.js
    this.setState({ selectedDCNbr: val ?? [], dcerrorMsg: '' });
  }

  handleSearchType(event) {
    const type = event.target.value;
    this.setState({
      searchType: type,
      showItemSearch: type === 'itemNumbers'
    });
  }

  setSelectedDcList(val) {
    this.setState({
      selectedDcList: val
    });
  }

  handleDCPaste = event => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text');
    
    const validDCs = [];
    const invalidDCs = [];
    const nonNumericTokens = [];
    
    pastedText
      .split(/[,;\s]+/)
      .forEach(token => {
        const trimmed = token.trim();
        if (!trimmed) return;
        
        if (!/^\d+$/.test(trimmed)) {
          nonNumericTokens.push(trimmed);
          return;
        }
        
        const paddedDC = trimmed.length === 4 ? '0' + trimmed : trimmed;
        
        if (this.state.dcList.includes(paddedDC)) {
          validDCs.push(paddedDC);
        } else {
          invalidDCs.push(paddedDC);
        }
      });
    
    if (validDCs.length > 0) {
      const uniqueDCs = [...new Set([...this.state.selectedDcList, ...validDCs])];
      this.setSelectedDcList(uniqueDCs);
    }
    
    const errorMessages = [];
    if (nonNumericTokens.length > 0) {
      errorMessages.push(`Non-numeric values ignored: ${nonNumericTokens.join(', ')}`);
    }
    if (invalidDCs.length > 0) {
      errorMessages.push(`Invalid DC numbers: ${invalidDCs.join(', ')}`);
    }
    
    if (errorMessages.length > 0) {
      this.context.showMsgCallback(errorMessages.join('. '));
    }
    /* istanbul ignore next */
    if (errorMessages.length === 0 && validDCs.length === 0 && (nonNumericTokens.length > 0 || invalidDCs.length > 0)) {
      this.context.showMsgCallback('No valid DC numbers found in pasted text');
    }
  };

  getAutocompleteValue() {
    if (this.state.searchType === 'wpidNumbers') return this.state.wpidNbrs;
    return this.state.showItemSearch ? this.state.itemNumbers : this.state.vendorNbrs;
  }

  getAutocompleteErrorMsg() {
    if (this.state.searchType === 'wpidNumbers') return this.state.wpidErrorMsg;
    return this.state.showItemSearch ? this.state.itemerrorMsg : this.state.vendorErrorMsg;
  }

  render() {
    return (
      <Context.Consumer>
        {context => (
          <div role="tablist" className={impstyles.searchCard} ref={this.searchCardRef}>
            <div
              role="tab"
              tabIndex="-1"
              className={impstyles.searchTitle}
              onClick={() => this.toggleCollapse()}
              onKeyDown={() => this.toggleCollapse()}
              data-testid="toggleCollapse"
            >
              <span className={impstyles.title}> </span>
              <span style={{ flex: 1 }} />
            </div>
            {this.state.dcList.length > 0 && (
              <Collapse
                className={impstyles.collapseCard}
                in={!this.state.collapse}
                timeout="auto"
                unmountOnExit
              >
                <div className={impstyles.insideDiv} role="tablist">
                  <div className={impstyles.searchCategory}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="item-numbers-and-VendorID"
                        name="position"
                        value={this.state.searchType}
                        onChange={this.handleSearchType.bind(this)}
                        data-testid="radio-group"
                        sx={{ columnGap: '40px' }}
                      >
                        <FormControlLabel
                          sx={{
                            marginRight: 0,
                            '& .MuiFormControlLabel-label': {
                              fontSize: 13,
                              fontFamily: ["canada-type-gibson", "Roboto", "sans-serif"],
                              marginTop: 0.5,
                              color: this.context.colorTheme === 'dark' ? '#E6E6E6' : 'inherit'
                            }
                          }}
                          value="itemNumbers"
                          className={impstyles.radioButtonSize}
                          control={<SearchRadioBtn sx={{ padding: '4px' }} />}
                          label="Item numbers"
                        />
                        <FormControlLabel
                          sx={{
                            marginRight: 0,
                            '& .MuiFormControlLabel-label': {
                              fontSize: 13,
                              fontFamily: ["canada-type-gibson", "Roboto", "sans-serif"],
                              marginTop: 0.5,
                              color: this.context.colorTheme === 'dark' ? '#E6E6E6' : 'inherit'
                            }
                          }}
                          value="vendorIDs"
                          className={impstyles.radioButtonSize}
                          control={<SearchRadioBtn sx={{ padding: '4px' }} />}
                          label="Vendor IDs"
                        />
                        {this.context.nonVariantEnabled && (
                          <FormControlLabel
                            sx={{
                              marginRight: 0,
                              '& .MuiFormControlLabel-label': {
                                fontSize: 13,
                                fontFamily: ["canada-type-gibson", "Roboto", "sans-serif"],
                                marginTop: 0.5,
                                color: this.context.colorTheme === 'dark' ? '#E6E6E6' : 'inherit'
                              }
                            }}
                            value="wpidNumbers"
                            className={impstyles.radioButtonSize}
                            control={<SearchRadioBtn sx={{ padding: '4px' }} />}
                            label="WPID"
                          />
                        )}
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div id="autocomp" style={{ marginTop: 9 }}>
                    <DCAutoComplete
                      style={{ border: 'none', marginTop: 9 }}
                      value={this.getAutocompleteValue()}
                      newAAutoVal={this.autocompleteValCallback.bind(this)}
                      errormsg={this.getAutocompleteErrorMsg()}
                      validator={
                        this.state.searchType === 'wpidNumbers'
                          ? t => /^[A-Za-z0-9 -]+$/.test(t)
                          : t => /^\d+$/.test(t)
                      }
                    />
                  </div>
                </div>
                <div className={impstyles.dcSelector}>
                  <div style={{ padding: '5px 0px' }}>
                    <span className={impstyles.insideFont}>
                      {' '}
                      Select Distribution Centers{' '}
                    </span>
                  </div>
                  <div id='search-multiselect' className={impstyles.multiSelect}>
                    <MultiSelect
                      items={this.state.dcList}
                      selectAllLabel="Select all"
                      onChange={this.setSelectedDcList.bind(this)}
                      searchedDcValues={this.state.selectedDcList}
                      triggerSearch={this.onSearch.bind(this)}
                      onPaste={this.handleDCPaste}
                    />
                  </div>
                  <div>
                    <span className={impstyles.dropdownSubtext}>
                      {' '}
                      If set to multiple or all you can toggle between them
                      quickly{' '}
                    </span>
                  </div>

                  <Typography
                    style={{
                      position: 'relative',
                      display: 'flex',
                      background: this.context.colorTheme === 'dark' ? '#1A1A1A' : '#E7EDF6',
                      margin: '0',
                      left: '-16px',
                      width: '387px',
                      top: 'calc(100vh - 456px)',
                      height: '80px',
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <MinimalButton
                      className={impstyles.closeButton}
                      variant="text"
                      onClick={this.props.showHideSidenav}
                    >
                      <div>Close</div>
                    </MinimalButton>
                    <BlueButton
                      className={impstyles.searchButton}
                      onClick={this.onSearch.bind(this)}
                      loading={this.state.loading}
                      disabled={
                        this.state.itemNumbers.length === 0 &&
                        this.state.vendorNbrs.length === 0 &&
                        this.state.wpidNbrs.length === 0
                      }
                      data-testid="PrimaryButtonClick"
                    >
                      Search
                    </BlueButton>
                  </Typography>
                </div>
              </Collapse>
            )}
            {this.state.dcList.length === 0 && <CircularProgress size={50} style={{ margin: "80% 45%" }} />}
          </div>
        )}
      </Context.Consumer>
    );
  }
}
Search.contextType = Context;

Search.propTypes = {
  dcList: PropTypes.array.isRequired,
  selectedSavedSearch: PropTypes.shape({
    vendorNbr: PropTypes.array,
    itemNbr: PropTypes.array,
    wpids: PropTypes.array,
    dcNbr: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  }),
  showHideSidenav: PropTypes.func.isRequired
};

export default withStyles(styles)(Search);
